var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevronUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.143 16.58l.805.781c.19.185.499.185.69 0L12 10.225l7.363 7.136c.19.185.499.185.69 0l.804-.782a.465.465 0 000-.67l-8.512-8.27a.498.498 0 00-.69 0l-8.512 8.27a.464.464 0 000 .67z",
    fill: "#777"
  })));
}

export default SvgChevronUp;